import { component, prop } from '../../../decorators';

import MetadataInfo from '../metadata-info/metadata-info.vue';

import isString from 'lodash/isString';

@component({
   components: { MetadataInfo }
})
export default class Tag {
   @prop({ required: true }) item
   @prop({ type: Boolean, default: false }) disabled
   @prop({ type: Boolean, default: true }) ellipsis

   get isPrimitive() {
      return isString(this.item);
   }

   get label() {
      return this.isPrimitive ? this.item : this.item.name;
   }

   get type() {
      return this.isPrimitive ? '' : this.item.type;
   }

   get thumbnailUrl() {
      return this.isPrimitive ? '' : this.item.thumbnailUrl;
   }
}
